/**
 * CropModalContextProvider
 *
 * Creates the reducer and merges external props (cropId, open, onClose)
 * into the context value alongside reducer state.
 *
 * Pattern mirrors TimelineContextProvider.
 */

import { useReducer, useMemo } from 'react'
import { initialState, CropModalContextReducer } from './crop-modal-context-reducer'
import { CropModalContext, CropModalContextDispatch } from './crop-modal-context'

export const CropModalContextProvider = ({ children, cropId, open, onClose }) => {
  const [state, dispatch] = useReducer(CropModalContextReducer, initialState)

  const mergedValue = useMemo(() => ({
    ...state,
    cropId,
    open,
    onClose,
  }), [state, cropId, open, onClose])

  return (
    <CropModalContext.Provider value={mergedValue}>
      <CropModalContextDispatch.Provider value={dispatch}>
        {children}
      </CropModalContextDispatch.Provider>
    </CropModalContext.Provider>
  )
}
